
require('../cdiv-header/cdiv-header.html');

require('../cdiv-footer-links/cdiv-footer-links.html');

const RegisterHtmlTemplate = require('polymer-webpack-loader/register-html-template');

RegisterHtmlTemplate.register("<dom-module id=cdiv-page> <template><style>" + require("./cdiv-page.css") + "</style> <slot></slot> </template> </dom-module>");

require('./cdiv-page.js');



// WEBPACK FOOTER //
// ./cdiv/en-US/js/cdiv-page/cdiv-page.html